const blog = [
  {
    path: 'categories',
    name: 'blog.categories',
    component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Categories/Index.vue'),
    meta: {
      requiredAuth: true
    }
  },
  {
    path: 'posts',
    name: 'blog.posts',
    component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Posts/Index.vue'),
    meta: {
      requiredAuth: true
    },
    children: [
      {
        path: 'create',
        name: 'blog.posts.create',
        component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Posts/CreatePost.vue'),
        meta: {
          requiredAuth: true
        }
      },
      {
        path: ':slug',
        name: 'blog.posts.view',
        component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Posts/ViewPost.vue'),
        meta: {
          requiredAuth: true
        }
      }
    ]
  },
  {
    path: 'tags',
    name: 'blog.tags',
    component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Tags/Index.vue'),
    meta: {
      requiredAuth: true
    }
  },
  {
    path: 'gallery',
    name: 'blog.gallery',
    component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Gallery/Index.vue'),
    meta: {
      requiredAuth: true
    }
  }
]

export default blog
